  import { Form } from 'react-bootstrap';
  const Input = ({name, value, onChange, placeholder, disabled = false, required=false, type}) => {
    return (
      <Form.Control
        disabled={disabled}
        className="input"
        name={name}
        value={value}
        onChange={onChange}
        type={type}
        placeholder={placeholder}
        required={required}
      />
    );
  };

  export default Input
